import { getLoadout } from "@/data/loadouts";

const pickOne = (arr) => (arr && arr.length ? arr[Math.floor(Math.random() * arr.length)] : null);

/**
 * Roll a loadout suggestion (weapons only).
 * @param {object} op   operator object (needs .id)
 * @param {"attacker"|"defender"} side
 * @param {object} toggles { primary, secondary, gadget }
 * @returns {object|null}
 */
export const rollLoadout = (op, side, toggles) => {
  if (!op) return null;
  if (!toggles.primary && !toggles.secondary && !toggles.gadget) return null;
  const data = getLoadout(op.id, side);
  return {
    primary: toggles.primary ? pickOne(data.primary) : null,
    secondary: toggles.secondary ? pickOne(data.secondary) : null,
    gadget: toggles.gadget ? pickOne(data.gadget) : null,
  };
};

export const loadoutIsEmpty = (l) => !l || (!l.primary && !l.secondary && !l.gadget);
